import type { ProjectLaunchOrderData } from '@/components/Markdown/MarkdownViewer/CustomTagCom/ProjectLaunchOrder/const';
import type { ChatMessage } from '@/stores/chat/types';
import { useMemo } from 'react';
import { parseProjectLaunchOrderData } from '@/components/Markdown/MarkdownViewer/CustomTagCom/ProjectLaunchOrder/const';
import { resolveConfirmedReferenceFromConversation } from '@/helpers/inlineReferenceSelection';
import { useChatStore } from '@/stores/chat';
import { useUserStore } from '@/stores/user';

export function resolveProjectLaunchOrderFromMessages(messages: ChatMessage[]): ProjectLaunchOrderData | null {
  for (let index = messages.length - 1; index >= 0; index -= 1) {
    const message = messages[index];

    if (message.role !== 'tool_call' || message.toolName !== 'create_project_launch' || !message.output) {
      continue;
    }

    const content = typeof message.output === 'string'
      ? message.output
      : JSON.stringify(message.output);
    const order = parseProjectLaunchOrderData(content);
    if (!order) {
      continue;
    }
    if (order.referenceImageUrl) {
      return order;
    }

    const selectedReference = resolveConfirmedReferenceFromConversation(messages);
    return selectedReference
      ? {
          ...order,
          referenceImageUrl: selectedReference.url,
          visualDirection:
            order.visualDirection
            || selectedReference.styleDisplayName
            || selectedReference.styleName,
        }
      : order;
  }

  return null;
}

export function useProjectLaunchOrder(): ProjectLaunchOrderData | null {
  const messages = useChatStore(state => state.messages);
  const isFreeUser = useUserStore(state => state.isFreeUser);

  return useMemo(() => {
    if (!isFreeUser) {
      return null;
    }

    return resolveProjectLaunchOrderFromMessages(messages);
  }, [isFreeUser, messages]);
}
